module.exports = __webpack_public_path__ + "static/media/Instagram.eaf14526.png";